import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import Header from "../../layouts/Header";
import upArrow from "../../assets/icons/upArrow.png";
import InvoiceDoller from "../../assets/icons/InvoiceDoller.svg";
import blackDoller from "../../assets/icons/blackDoller.svg";
import CreditNote from "../../assets/icons/CreditNote.svg";
import FilterContacts from "../../assets/icons/FilterContacts.svg";
import AddIcon from "../../assets/icons/addicon.svg";
import Xicon from "../../assets/icons/Xicon.svg";
import editIcon from "../../assets/icons/editIcon.svg";
import bin from "../../assets/icons/Bin.svg";
import send from "../../assets/icons/send.svg";
import Pdf_icon from "../../assets/icons/Pdf icon.svg";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import TaskDelete from "../../components/Dailogs/TaskDelete";
import "../../assets/styles/local/InvoiceAllList.css";
import Collapse from "react-bootstrap/Collapse";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { IoReload } from "react-icons/io5";
import { handleGeneralNotification } from "../../utils/helpers/notifications";

import {
  FetchInvoiceList,
  InvoiceDelete,
  SendInvoice,
  GetSendInvoiceCount,
  invoiceSendEmailCount,
} from "../../redux/actions/action";
import { SEND_INVOICE_EMAIL } from "../../redux/constants/type";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Pagination from "../../components/Pagination/Pagination";

import html2pdf from "html2pdf.js";
import InvoicePDF from "../../assets/pdfs/InvoicePDF";
import grapesTemplateApi from "../../services/grapesTemplateApi";
import Loader from "../../components/Dailogs/Loader";

const InvoiceAllList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  // const { param1, param2, projectname } = location.state;
  const filter_Popup_Ref = useRef(null);
  const add_New_Popup_Ref = useRef(null);
  const hidden_Input_File = useRef(null);

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");
  const [showRecurringSuccessPopup, setShowRecurringSuccessPopup] =
    useState(false);

  useEffect(() => {
    if (location.state?.recurringJustSet === true) {
      setShowRecurringSuccessPopup(true);
      history.replace(location.pathname, {});
    }
  }, []);

  const fetchInvoioceAllList = useSelector(
    (state) => state.user.fetchInvoioceAllList,
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Invoice-List-Add-Update").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const invoiceDeleteRes = useSelector((state) => state.user.invoiceDeleteRes);
  const sendInvoiceEmailRes = useSelector(
    (state) => state.user.sendInvoiceEmailRes,
  );
  const sendInvoiceEmailCountRes = useSelector(
    (state) => state.user.sendInvoiceEmailCountRes,
  );
  const invoiceGenratePDFRes = useSelector(
    (state) => state.user.invoiceGenratePDFRes,
  );

  // VARIABLES START //

  ///////////// asc for cancel modal popup start //////////
  const [modalShow, setModalShow] = useState(false);
  const handleClose = () => setModalShow(false);

  const handleCancel = (e) => {
    // history.push("/project");
    history.goBack();
  };
  ///////////// asc for cancel modal popup end //////////

  ///////////// asc for Delete modal popup start //////////
  const [showPopup, setShowPopup] = useState(false);
  const [invoiceDelete, setInvoiceDelete] = useState("");
  const handleDelete = (e) => {
    dispatch(InvoiceDelete(invoiceDelete));
    setShowPopup(false);
  };
  ///////////// asc for Delete modal popup end //////////

  const [apimessage, setApimessage] = useState("");
  const [querystring, setQuerystring] = useState("");
  const [invoiceAllListData, setInvoiceAllListData] = useState([]);
  const [invoiceId, setInvoiceId] = useState("");
  const [invoiceCode, setInvoiceCode] = useState("");
  const [invoiceClientName, setInvoiceClientName] = useState("");
  const [btnHover, setBtnHover] = useState(false);
  const [filtersPopupShow, setFiltersPopupShow] = useState(false);
  const [addNewPopupShow, setAddNewPopupShow] = useState(false);
  const [invoicePDFData, setInvoicePDFData] = useState([]);
  // console.log("asc677", invoicePDFData);

  const [sendEmailShow, setSendEmailShow] = useState(false);
  const [sendEmailTxtShow, setSendEmailTxtShow] = useState(false);
  const [email, setEmail] = useState("");
  const [validemail, setValidemail] = useState(false);
  const [listHover, setListHover] = useState(false);
  const [asc_invoiceID, setAsc_invoiceID] = useState("");
  const [hignlightInvoice, setHignlightInvoice] = useState(null);
  const [emailCountData, setEmailCountData] = useState([]);
  const [emailCount, setEmailCount] = useState("");
  const [downloadingInvoiceId, setDownloadingInvoiceId] = useState(null);

  // for sort by
  const [shortByArrow, setShortByArrow] = useState(false);
  const [showShortDrop, setShowShortDrop] = useState(false);
  const [sortedValue, setSortedValue] = useState("Date");

  // if we want radio check uncheck then make it only one state //
  const [allFilter, setAllFilter] = useState(true);
  const [sentFilter, setSentFilter] = useState(false);
  const [notSentFilter, setNotSentFilter] = useState(false);
  const [draftFilter, setDraftFilter] = useState(false);
  const [invoicedFilter, setInvoicedFilter] = useState(false);
  const [notInvoicedFilter, setNotInvoicedFilter] = useState(false);

  // asc filter status variables....
  const [allStatus, setAllStatus] = useState("");
  const [sentStatus, setSentStatus] = useState("");
  const [notSentStatus, setNotSentStatus] = useState("");
  const [draftStatus, setDraftStatus] = useState("");
  const [invoicedStatus, setInvoicedStatus] = useState("");
  const [notInvoicedStatus, setNotInvoicedStatus] = useState("");

  // for pagination start
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  // for pagination end

  useEffect(() => {
    // dispatch(FetchInvoiceList(companyId));
    // dispatch(invoiceSendEmailCount(companyId));
    // dispatch(GetSendInvoiceCount(invoiceId));
  }, [sendInvoiceEmailRes]);

  useEffect(() => {
    if (invoiceGenratePDFRes.status === true) {
      setInvoicePDFData(invoiceGenratePDFRes.data);
    }
  }, [invoiceGenratePDFRes]);

  useEffect(() => {
    // const sortedPayload = {
    //   orderby: shortByArrow ? "descending" : "ascending",
    //   type: sortedValue,
    // };

    const sortedPayload = shortByArrow
      ? `Ascending-${sortedValue}`
      : `Descending-${sortedValue}`;

    let statusFilter = [
      "Draft",
      "Sent",
      "Not Sent",
      "Invoiced",
      "Not Invoiced",
      "Deleted",
      "Credited",
      "Credit",
    ];
    let statusFilter2 = [
      draftFilter ? "Draft" : "",
      sentFilter ? "Sent" : "",
      notSentFilter ? "Not Sent" : "",
      invoicedFilter ? "Invoiced" : "",
      notInvoicedFilter ? "Not Invoiced" : "",
    ];

    if (querystring) {
      dispatch(
        FetchInvoiceList(companyId, sortedPayload, querystring, statusFilter),
      );
    } else if (allFilter) {
      dispatch(
        FetchInvoiceList(companyId, sortedPayload, querystring, statusFilter),
      );
    } else {
      dispatch(
        FetchInvoiceList(companyId, sortedPayload, querystring, statusFilter2),
      );
    }
  }, [
    dispatch,
    shortByArrow,
    sortedValue,
    allFilter,
    sentFilter,
    notSentFilter,
    invoicedFilter,
    notInvoicedFilter,
    querystring,
    invoiceDeleteRes,
    sendInvoiceEmailRes,
  ]);

  // fetch All Invoice Data responce start //
  useEffect(() => {
    if (fetchInvoioceAllList.status === true) {
      // setApimessage(fetchInvoioceAllList?.message)
      setInvoiceAllListData(fetchInvoioceAllList.data);
      let allInvoiceID = fetchInvoioceAllList.data.map((x) => x.invoiceid);
      // dispatch(invoiceSendEmailCount(allInvoiceID));

      setTotalPages(Math.ceil(fetchInvoioceAllList.data.length / perPage));
    } else {
      setApimessage(fetchInvoioceAllList?.message);
    }
  }, [fetchInvoioceAllList, perPage]);
  // fetch All Invoice Data responce end //

  // email send responce start
  useEffect(() => {
    if (sendInvoiceEmailRes?.status === true) {
      setSendEmailTxtShow(true);

      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: `Invoice ID ${invoiceCode} was sent successfully.`,
        },
        false,
      );

      setTimeout(() => {
        setSendEmailTxtShow(false);
      }, 2000);

      setTimeout(() => {
        setSendEmailShow(false);
        setShowLoader(false);
      }, 3000);

      dispatch({
        type: SEND_INVOICE_EMAIL,
        data: {},
      });
    } else if (sendInvoiceEmailRes?.status === false) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: sendInvoiceEmailRes.message || "Unable to send the invoice email.",
        },
        false,
      );
      setShowLoader(false);
      dispatch({
        type: SEND_INVOICE_EMAIL,
        data: {},
      });
    }
  }, [sendInvoiceEmailRes]);
  // email send responce end

  // email send Count responce start
  useEffect(() => {
    if (sendInvoiceEmailCountRes.status === true) {
      setEmailCountData(sendInvoiceEmailCountRes.data);
    }
  }, [sendInvoiceEmailCountRes]);
  // email send Count responce end

  // invoice delete responce start
  useEffect(() => {
    if (invoiceDeleteRes.status === true) {
      // setApimessage(invoiceDeleteRes?.message)
      // dispatch(FetchInvoiceList(companyId));
    } else {
      setApimessage(invoiceDeleteRes?.message);
    }
  }, [invoiceDeleteRes]);
  // invoice delete responce end

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      filter_Popup_Ref.current &&
      !filter_Popup_Ref.current.contains(event.target)
    ) {
      setFiltersPopupShow(false);
    }
    if (
      add_New_Popup_Ref.current &&
      !add_New_Popup_Ref.current.contains(event.target)
    ) {
      setAddNewPopupShow(false);
    }
    // if (type_an_item_Drop_Ref.current && !type_an_item_Drop_Ref.current.contains(event.target)) {
    //   setShowProductsPeople(false);
    // }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  let vat = invoiceAllListData.filter(
    (item) => item.invoicestatus === notSentStatus,
  );

  // sort by options start
  // const sortByOption = [
  //   { label: "Date", value: "Date" },
  //   { label: "Doc ID", value: "DocID" },
  //   { label: "Client", value: "Client" },
  //   { label: "Due Date", value: "DueDate" },
  //   { label: "Status", value: "Status" },
  // ];
  const sortByOption = [
    { label: t("Date"), value: "Date" },
    { label: t("Doc ID"), value: "DocID" },
    { label: t("Client"), value: "Client" },
    { label: t("Due Date"), value: "DueDate" },
    { label: t("Status"), value: "Status" },
  ];
  // sort by options end

  const checkEmailValidation = (e) => {
    // const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emails = e.target.value;
    if (!emailPattern.test(emails) && emails.trim() !== "") {
      setValidemail(true);
    } else {
      setValidemail(false);
    }
  };

  // ASC pdf for start
  const convertToPDF = (selectedName) => {
    if (invoiceGenratePDFRes.status === true) {
      const element = document.getElementById("teamPDFSection");

      html2pdf()
        .from(element)
        .set({
          filename: `${selectedName}.pdf`,
          // margin: [5, 5, 20, 5], // Top, Left, Bottom, Right
          margin: [10, 0, 30, 0], // Top, Left, Bottom, Right
          pagebreak: { mode: ["css", "legacy"] },
          html2canvas: { scale: 8 }, // not more then 9
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        })
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            // pdf.text("ASC", 90, 290); // x = 90, y = 290 (below in pdf)

            pdf.setFontSize(7);
            pdf.setTextColor((51, 51, 51));
            // VAT No. rotated
            pdf.text(`VAT No. ${invoicePDFData.company.vatNo}`, 8, 290, {
              angle: -270,
            });

            pdf.setFontSize(7);
            // Footer content (Bottom Left)
            // pdf.text("Spire Solutions", 15, 280);
            pdf.text(invoicePDFData.company.name, 15, 280);

            // pdf.text(invoicePDFData.address, 15, 285);

            const address = invoicePDFData.address;
            const lastCommaIndex = address.lastIndexOf(",");
            const firstPart = address.substring(0, lastCommaIndex);
            const secondPart = address.substring(lastCommaIndex + 1).trim();

            const firstPart2 =
              address?.length > 50 ? address.slice(0, 50) : address;
            const secondPart2 =
              address?.length > 50 ? address.slice(50).trim() : "";

            let firstPart3 = address;
            let secondPart3 = "";

            if (address.length > 55) {
              const trimmed = address.slice(0, 55);
              const lastSpace = trimmed.lastIndexOf(" ");

              firstPart3 = trimmed.slice(0, lastSpace);
              secondPart3 = address.slice(lastSpace).trim();
            }

            pdf.text(firstPart2, 15, 285);
            pdf.text(secondPart2, 15, 290);

            // Footer content (Bottom Right)
            pdf.text(invoicePDFData.company.website, 80, 280);
            pdf.text(invoicePDFData.email, 80, 285);
            pdf.text(`KvK no. ${invoicePDFData.company.kvkNo ?? ""}`, 80, 290);

            // Page number at bottom right
            pdf.text(
              `Powered by www.spire.solutions | Pag.${i} of ${totalPages}`,
              130,
              290,
            ); // x = 150, y = 293(below right in pdf)
          }
          pdf.save(`${selectedName}.pdf`);
        });
    }
  };
  // ASC pdf for end

  const downloadDefaultGrapesInvoicePdf = async (invoice) => {
    setDownloadingInvoiceId(invoice.invoiceid);

    try {
      const response = await grapesTemplateApi.renderDefaultInvoicePdf(
        invoice.invoiceid,
      );
      if (!response.headers["content-type"]?.includes("application/pdf")) {
        const payload = JSON.parse(await response.data.text());
        throw new Error(payload?.message || "Unable to generate the default invoice template PDF.");
      }

      const objectUrl = URL.createObjectURL(response.data);
      const downloadLink = document.createElement("a");
      const contentDisposition = response.headers["content-disposition"] || "";
      const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);

      downloadLink.href = objectUrl;
      downloadLink.download = fileNameMatch?.[1]?.replace(/["']/g, "") || `${invoice.invoicecode}.pdf`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      let message = error?.message || "Unable to download the default invoice template PDF.";
      if (error?.response?.data instanceof Blob) {
        try {
          const payload = JSON.parse(await error.response.data.text());
          message = payload?.message || message;
        } catch {
          // The response is not JSON, so keep the safe fallback message.
        }
      }

      handleGeneralNotification({ notificationType: "CUSTOM", text: message }, false);
    } finally {
      setDownloadingInvoiceId(null);
    }
  };

  const [showLoader, setShowLoader] = useState(false);
  return (
    <section>
      {downloadingInvoiceId && (
        <div className="document-download-loader" role="status" aria-live="polite">
          <Loader />
          <p>Preparing PDF download...</p>
        </div>
      )}
      <Header
        setQuery={setQuerystring}
        leftComponent={
          <div className="d-flex align-items-baseline flex-wrap gap-4">
            <div
              className="invoiceText"
              onClick={() => {
                history.push("/project");
              }}
            >
              {/* Projects */}
              {t("Projects")}
              {/* {FetchTranslationList?.data?.data[ 8 ]?.translation} */}
            </div>
            <div className="pt-2 d-flex pe-3" style={{ background: "#FFFFFF" }}>
              <p className="pt-1 ps-4 invoiceText2">
                {/* Invoices */}
                {t("Invoices")}
                {/* {FetchTranslationList?.data?.data[ 55 ]?.translation} */}
              </p>
              {/* <p className="pt-1 projectID ps-5"> &nbsp;{invoiceId} </p> */}
            </div>
          </div>
        }
      />

      {showPopup && (
        <TaskDelete
          animation={true}
          handleDelete={handleDelete}
          show={showPopup}
          onHide={() => setShowPopup(false)}
        />
      )}

      <div className="ps-">
        <div className="afterHeader px-5">
          <sortSection
            className="d-flex gap-3"
            style={{ position: "relative" }}
          >
            <p className="sortBy">
              {/* Sort by */}
              {t("Sort by")}
            </p>
            <img
              className={
                shortByArrow
                  ? "downSortArrow mt-1 pointer"
                  : "upSortArrow mt-1 pointer"
              }
              src={upArrow}
              alt=""
              onClick={() => {
                setShortByArrow(!shortByArrow);
              }}
            />
            <p
              className="datetext pointer"
              onClick={() => setShowShortDrop(!showShortDrop)}
            >
              {sortedValue ? sortedValue : "Select"}
            </p>

            <div
              className="sortDropDiv p-3"
              style={{
                transform: showShortDrop ? "scale(1)" : "scale(0)",
                transitionDuration: "300ms",
              }}
            >
              {sortByOption.map((item, index) => {
                return (
                  <div
                    className={
                      sortedValue === item.value
                        ? "datetext pointer"
                        : "pointer"
                    }
                    onClick={() => {
                      setSortedValue(item.value);
                      setShowShortDrop(false);
                    }}
                  >
                    <p className="d-flex gap-">
                      {item.label}
                      {sortedValue === item.value && (
                        <p className="mb-0 ps-3">✓</p>
                      )}
                    </p>
                  </div>
                );
              })}
            </div>
          </sortSection>

          <filterSection
            className="d-flex gap-2 filterTexts positionForFilterPopup"
            ref={filter_Popup_Ref}
          >
            <p>
              {/* Filters */}
              {t("Filters")}
            </p>
            <img
              className="mb-3 pointer"
              src={FilterContacts}
              alt=""
              onClick={() => setFiltersPopupShow(true)}
            />
            <div className="d-flex gap-0">
              <p className="allBorder ps-1 pb-4">
                {[
                  allFilter ? "All" : "",
                  sentFilter ? "Sent" : "",
                  notSentFilter ? "Not Sent" : "",
                  invoicedFilter ? "Invoiced" : "",
                  notInvoicedFilter ? "Not Invoiced" : "",
                ]
                  .filter(Boolean)
                  .join(", ")}
              </p>
              {/* <p className="xIconInvoice px-1 pb-4">x</p> */}
            </div>

            {/*ASC filter popup start */}
            <section
              className="filterPopup"
              style={{
                transform: filtersPopupShow ? "scale(1)" : "scale(0)",
                transitionDuration: "300ms",
              }}
            >
              <p
                className="xCiecle ms-auto me-3 mt-1 pointer"
                onClick={() => {
                  setFiltersPopupShow(false);
                }}
              >
                x
              </p>

              <div class="form-check underTexts">
                <input
                  class="form-check-input pointer"
                  style={{ borderRadius: "50%", width: "15px", height: "15px" }}
                  type="checkbox"
                  // value="All"
                  id="ascInvoice"
                  checked={allFilter}
                  onClick={() => {
                    setAllFilter(!allFilter);
                    // setIsActive("one");
                    setSentFilter(false);
                    setNotSentFilter(false);
                    setInvoicedFilter(false);
                    setNotInvoicedFilter(false);
                  }}
                />
                <label class="form-check-label" for="flexCheckChecked">
                  <p className="mb-0">
                    {/* All */}
                    {t("All")}
                  </p>
                </label>
              </div>

              <div class="form-check underTexts">
                <input
                  class="form-check-input pointer"
                  style={{ borderRadius: "50%", width: "15px", height: "15px" }}
                  type="checkbox"
                  // value="Draft"
                  id="ascInvoice"
                  checked={draftFilter}
                  onClick={() => {
                    setDraftFilter(!draftFilter);
                    setDraftStatus("Draft");
                    setAllFilter(false);
                  }}
                />
                <label class="form-check-label" for="flexCheckDefault">
                  <p className="mb-0">
                    {/* Draft */}
                    {t("Draft")}
                  </p>
                </label>
              </div>

              <div class="form-check underTexts">
                <input
                  class="form-check-input pointer"
                  style={{ borderRadius: "50%", width: "15px", height: "15px" }}
                  type="checkbox"
                  value="Sent"
                  id="ascInvoice"
                  checked={sentFilter}
                  onClick={() => {
                    setSentFilter(!sentFilter);
                    setSentStatus("Sent");
                    setAllFilter(false);
                  }}
                />
                <label class="form-check-label" for="flexCheckDefault">
                  <p className="mb-0">
                    {/* Sent */}
                    {t("Sent")}
                  </p>
                </label>
              </div>

              <div class="form-check underTexts">
                <input
                  class="form-check-input pointer"
                  style={{ borderRadius: "50%", width: "15px", height: "15px" }}
                  type="checkbox"
                  // value="Not Sent"
                  id="ascInvoice"
                  checked={notSentFilter}
                  onClick={() => {
                    setNotSentFilter(!notSentFilter);
                    setNotSentStatus("Not Sent");
                    setAllFilter(false);
                  }}
                />
                <label class="form-check-label" for="flexCheckDefault">
                  <p className="mb-0">
                    {/* Not Sent */}
                    {t("Not Sent")}
                  </p>
                </label>
              </div>

              <div class="form-check underTexts">
                <input
                  class="form-check-input pointer"
                  style={{ borderRadius: "50%", width: "15px", height: "15px" }}
                  type="checkbox"
                  // value="Invoiced"
                  id="ascInvoice"
                  checked={invoicedFilter}
                  onClick={() => {
                    setInvoicedFilter(!invoicedFilter);
                    setInvoicedStatus("Invoiced");
                    setAllFilter(false);
                  }}
                />
                <label class="form-check-label" for="flexCheckDefault">
                  <p className="mb-0">
                    {/* Invoiced */}
                    {t("Invoiced")}
                  </p>
                </label>
              </div>

              <div class="form-check underTexts">
                <input
                  class="form-check-input pointer"
                  style={{ borderRadius: "50%", width: "15px", height: "15px" }}
                  type="checkbox"
                  // value="Not invoiced"
                  id="ascInvoice"
                  checked={notInvoicedFilter}
                  onClick={() => {
                    setNotInvoicedFilter(!notInvoicedFilter);
                    setNotInvoicedStatus("Not Invoiced");
                    setAllFilter(false);
                  }}
                />
                <label class="form-check-label" for="flexCheckDefault">
                  <p className="mb-0">
                    {/* Not invoiced */}
                    {t("Not Invoiced")}
                  </p>
                </label>
              </div>

              <button
                className="clearButton m-3"
                onClick={() => {
                  setAllFilter(true);
                  setSentFilter(false);
                  setNotSentFilter(false);
                  setDraftFilter(false);
                  setInvoicedFilter(false);
                  setNotInvoicedFilter(false);
                  setSentStatus("");
                  setNotSentStatus("");
                  setDraftStatus("");
                  setInvoicedStatus("");
                  setNotInvoicedStatus("");
                }}
              >
                {/* Clear */}
                {t("Clear")}
              </button>
            </section>
            {/*ASC filter popup end */}
          </filterSection>

          <div
            className="d-flex gap-3 mobile-widthbtn"
            ref={add_New_Popup_Ref}
            style={{ position: "relative" }}
          >
            <button
              onClick={() => setAddNewPopupShow(true)}
              className="addInvoiceBtn"
              onMouseEnter={() => setBtnHover(true)}
              onMouseLeave={() => setBtnHover(false)}
            >
              {btnHover && <img className="plusAddIcon" src={AddIcon} alt="" />}
              {!btnHover && (
                <img className="InvoiceDoller" src={InvoiceDoller} alt="" />
              )}
              {/* Add New */}
              {t("Add New")}
            </button>
            {/*ASC AddNew popup start */}
            <div
              className="addNewPopup"
              style={{
                transform: addNewPopupShow ? "scale(1)" : "scale(0)",
                transitionDuration: "300ms",
                position: "absolute",
              }}
            >
              <div className="d-flex pt-4 ps-5 gap-4">
                <p>
                  {/* Choose the type of document */}
                  {t("Choose the type of document")}
                </p>
                <p
                  className="xCiecle pb-1 pointer"
                  onClick={() => {
                    setAddNewPopupShow(false);
                  }}
                >
                  x
                </p>
              </div>

              <Link to="/NewInvoice" style={{ textDecoration: "none" }}>
                <div className="invoiceDiv m-auto mt-5 pointer">
                  <img className="InvoiceDoller" src={blackDoller} alt="" />
                  <p className="mb-0">
                    {/* Invoice */}
                    {t("Invoice")}
                  </p>
                </div>
              </Link>

              <Link
                to={{
                  pathname: "/CreditNote",
                  state: { url: "/InvoiceAllList" },
                }}
                style={{ textDecoration: "none" }}
              >
                <div className="invoiceDiv m-auto mt-3 pointer">
                  <img className="InvoiceDoller" src={CreditNote} alt="" />
                  <p className="mb-0">
                    {/* Credit Note */}
                    {t("Credit Note")}
                  </p>
                </div>
              </Link>
            </div>
            {/*ASC AddNew popup end */}
          </div>
        </div>

        {showRecurringSuccessPopup && (
          <div className="recurring-active-overlay">
            <div className="recurring-active-popup">
              <h6 className="recurring-active-title">
                Recurring invoice Active
              </h6>
              <p className="recurring-active-msg">
                Invoice draft created for the time span, successfully.
              </p>
              <p className="recurring-active-msg">
                System will send them starting at the date recurring set.
              </p>
              <button
                className="recurring-active-ok-btn"
                onClick={() => setShowRecurringSuccessPopup(false)}
              >
                Ok
              </button>
            </div>
          </div>
        )}

        <div
          className="ascTableWrapper mt-3 mx-4 px-4"
          style={{ height: "unset", overflow: "unset" }}
        >
          <table className="table">
            <thead>
              <tr className="tableHeading">
                <th style={{ width: "16%" }}>
                  {/* Doc ID */}
                  {t("Doc ID")}
                </th>
                <th style={{ width: "10%" }}>
                  {/* Date */}
                  {t("Date")}
                </th>
                <th style={{ width: "28%" }}>
                  {/* Client */}
                  {t("Client")}
                </th>
                <th style={{ width: "10%" }}>
                  {/* Project ID */}
                  {t("Project ID")}
                </th>
                <th
                  style={{
                    width: "11%",
                    textAlign: "right",
                    paddingRight: "30px",
                  }}
                >
                  {/* Total Balance */}
                  {t("Total Balance")}
                </th>
                <th style={{ width: "14%", paddingLeft: "44px" }}>
                  {/* Due Date */}
                  {t("Due Date")}
                </th>
                <th style={{ paddingLeft: "55px" }}>
                  {/* Status */}
                  {t("Status")}
                </th>
              </tr>
            </thead>

            <tbody className="tabLine" id="invoiceTable">
              {invoiceAllListData
                .slice(currentPage * perPage, (currentPage + 1) * perPage)
                .map((item, index) => {
                  return (
                    <tr
                      className={
                        item.invoicestatus === "Draft"
                          ? "draftTxt"
                          : item?.invoicestatus === "Deleted"
                            ? "dltTxt"
                            : item?.invoicestatus === "Credited"
                              ? "creditedText"
                              : "invoiceTxt"
                      }
                      style={{
                        backgroundColor:
                          hignlightInvoice === item.invoiceid ? "#F1F1F1" : "",
                      }}
                      onMouseEnter={() => {
                        setListHover(true);
                        setAsc_invoiceID(item.invoiceid);
                        setHignlightInvoice(item?.creditInvoiceId);
                      }}
                      onMouseLeave={() => {
                        setListHover(false);
                        setAsc_invoiceID("");
                        setHignlightInvoice(null);
                      }}
                    >
                      <td className="pointer d-flex align-items-center">
                        <span
                          onClick={() => {
                            if (item.invoicestatus === "Not Sent") {
                              window.localStorage.setItem(
                                "project_invoiceid",
                                item.invoiceid,
                              );
                              history.push("/UpdateInvoice");
                            }
                          }}
                        >
                          {item.invoicestatus === "Draft"
                            ? "DRAFT"
                            : item.invoicecode}
                        </span>

                        {listHover && asc_invoiceID === item.invoiceid && (
                          <div
                            className="d-flex align-items-center ps-3 gap-3"
                            onClick={() => {
                              // localStorage.setItem("projectForPrint", projectname);
                              localStorage.setItem(
                                "QuoteNoForPrint",
                                item?.invoicecode,
                              );
                              localStorage.setItem(
                                "clientNameForPrint",
                                item?.clientname ?? "",
                              );
                            }}
                          >
                            {item.invoicestatus === "Credited" ? (
                              <label className="lable-credited">
                                {item.invoicestatus}
                              </label>
                            ) : (
                              item.invoicestatus !== "Deleted" && (
                                <>
                                  {item.invoicestatus === "Draft" && (
                                    <img
                                      className="invoIcon"
                                      src={editIcon}
                                      alt=""
                                      onClick={() => {
                                        window.localStorage.setItem(
                                          "project_invoiceid",
                                          item.invoiceid,
                                        );
                                        history.push("/UpdateInvoice");
                                      }}
                                    />
                                  )}

                                  {item.invoicestatus !== "Draft" && (
                                    <>
                                      <div
                                        className="sendIcon_CountNo"
                                        onClick={() => {
                                          setSendEmailShow(!sendEmailShow);
                                          setInvoiceId(item?.invoiceid);
                                          setInvoiceCode(item?.invoicecode);
                                          setInvoiceClientName(
                                            item?.clientname,
                                          );
                                          // dispatch(FetchInvoiceById(invoice?.invoiceid));
                                        }}
                                      >
                                        <img
                                          className="invoIcon"
                                          src={send}
                                          alt=""
                                        />
                                        {/* {emailCountData
                                          .filter(
                                            (mail) =>
                                              mail.invoiceid === item.invoiceid
                                          )
                                          .map((mail) => {
                                            return (
                                              <div className="countNumber">
                                                <p className="mb-0">
                                                  {mail.invoicePDFCount}
                                                </p>
                                              </div>
                                            );
                                          })} */}

                                        <div className="countNumber">
                                          <p className="mb-0">
                                            {item.invoiceSentCount}
                                          </p>
                                        </div>
                                      </div>
                                      <img
                                        className="invoIcon"
                                        src={Pdf_icon}
                                        alt="Download default invoice PDF"
                                        onClick={() => downloadDefaultGrapesInvoicePdf(item)}
                                        style={{ opacity: downloadingInvoiceId === item.invoiceid ? 0.5 : 1, pointerEvents: downloadingInvoiceId ? "none" : "auto" }}
                                      />
                                    </>
                                  )}

                                  {item.invoicestatus !== "Sent" && (
                                    <img
                                      className="invoIcon"
                                      src={bin}
                                      alt=""
                                      onClick={() => {
                                        // handleDelete(item, index);
                                        // dispatch(InvoiceDelete(item.invoiceid));
                                        setShowPopup(true);
                                        setInvoiceDelete(item.invoiceid);
                                      }}
                                    />
                                  )}
                                </>
                              )
                            )}
                          </div>
                        )}
                      </td>

                      <td>{moment(item.createdat).format("DD.MM.YYYY")}</td>
                      <td>{item.clientname}</td>
                      <td>{item.projectcode}</td>
                      <td className="total-balance-col">
                        {europeanFormatWithSymbol(item.total)}
                      </td>
                      <td className="due-date-col">
                        {item.invoicestatus === "Draft"
                          ? "-"
                          : moment(item.duedate).format("DD.MM.YYYY")}
                      </td>
                      <td
                        className={`${
                          item.invoicestatus === "Not Sent" ? "notSentTxt" : ""
                        } draft-col`}
                      >
                        {item.invoicestatus === "Draft" ? (
                          item.isRecurring ? (
                            <IoReload
                              size={18}
                              style={{ color: "#95a7c6", marginLeft: "15px" }}
                            />
                          ) : (
                            "-"
                          )
                        ) : (
                          item.invoicestatus
                        )}
                      </td>
                    </tr>
                  );
                })}
              {invoiceAllListData.length === 0 && (
                <span className="noDataDisplay">
                  {/* No data to display! */}
                  {t("No data to display!")}
                  {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                </span>
              )}
            </tbody>

            {/* <tbody className="tabLine">
              <tr>
                <td>Ankit</td>
              </tr>
              <tr>
                <td>Singh</td>
              </tr>
              <tr>
                <td>Chandel</td>
              </tr>
            </tbody> */}

            <section
              // className="emailPopup pt-3 ps-4"
              className={
                sendEmailShow
                  ? "emailPopup pt-3 ps-4 asc_animaTopStart"
                  : "emailPopup pt-3 ps-4 asc_animaBottomEnd"
              }
              style={{
                // transform: sendEmailShow ? "scale(1)" : "scale(0)",
                // transitionDuration: "500ms",

                // transform: sendEmailShow ? "none" : "scale(0.75, 0.5625)",
                // opacity: sendEmailShow ? 1 : 0,
                // transformOrigin: "0px 39.5px",
                // transition:
                //   "opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s, transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",

                position: "absolute",
                borderTop: "none",
              }}
            >
              <p
                className="xCiecle ms-auto me-5 mt-1 pointer"
                onClick={() => {
                  setSendEmailShow(false);
                  setShowLoader(false);
                }}
              >
                x
              </p>

              <div className="asc-input-container ms-2" id="ascInput">
                <label className="asc-label-top ClientNameText">
                  {/* Email */}
                  {t("Email")}
                </label>
                <input
                  type="email"
                  className="asc_NormalInput_invo ps-4"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value.toLowerCase().trim());
                    checkEmailValidation(e);
                  }}
                />
                <div
                  className={validemail ? "ps-1 py-2" : "invisible py-2"}
                  style={{ color: "red", fontSize: "14px" }}
                >
                  <i className="pe-1 bi bi-exclamation-circle"></i>
                  {/* Email is invalid */}
                  {t("Email is invalid")}
                </div>
              </div>

              <button
                id="ascButtonDisabled"
                disabled={validemail || email === ""}
                className="button_invo mt-3 pt-3 mx-auto"
                onClick={() => {
                  setShowLoader(true);
                  dispatch(SendInvoice(invoiceId, email, invoiceCode, ""));
                }}
              >
                <p className="bg-transparent">
                  {/* Send */}
                  {t("Send")}
                  {showLoader && (
                    <span className="ms-2">
                      <Spinner animation="border" size="sm" />
                    </span>
                  )}
                </p>
              </button>

              <div style={{ minHeight: "50px" }}>
                <Collapse in={sendEmailTxtShow} dimension="width">
                  <h6 className="text-success p-3">{`Mail send successfully to ${invoiceClientName}`}</h6>
                </Collapse>
              </div>
            </section>
          </table>

          <Pagination
            perPage={perPage}
            setPerPage={setPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        </div>
      </div>

      {/* SEND PROPS DATA TO InvoicePDF for PDF */}
      <div className="d-none">
        <InvoicePDF
          invoicePDFData={[invoicePDFData]}
          convertToPDF={convertToPDF}
        />
      </div>
    </section>
  );
};

export default InvoiceAllList;
